import { withCompController } from '@wix/editor-elements-integrations';
import type {
  IPopupContainerMapperProps,
  IPopupContainerControllerProps,
  IPopupContainerProps,
  IPopupContainerStateRefsValues,
} from '../PopupContainer.types';

export default withCompController<
  IPopupContainerMapperProps,
  IPopupContainerControllerProps,
  IPopupContainerProps,
  IPopupContainerStateRefsValues
>(({ mapperProps, stateValues }) => {
  const { pageId, setSiteScrollingBlocked } = stateValues;

  return {
    ...mapperProps,
    pageId,
    setSiteScrollingBlocked,
  };
});
